export const securitySettingsDeLegacy = {
  "securitySettings.walletApp.notificationMessage":
    "Legen Sie Ihre Loyalty Wallet {link} an. Für jede Wallet werden gesonderte Anmeldeinformationen benötigt. Nach dem Start Ihres Treueprogrammplans ist die Wallet aktiv. Wenn Sie SSO verwenden, wenden Sie sich an den SAP Emarsys Support, um Wallet-Anmeldeinformationen zu erhalten. {helpLink} "
};
